import React from "react";

{
  /*
  Filename:    SearchInstructions.js
  Description: This component guides a user on how to use Search Client.
*/
}

function SearchInstructions() {
  return (
    <React.Fragment>
      <div className="card shadow-sm h-100">
        <div className="card-header">
          <h4 className="text-center mb-0">
            <i className="bi bi-info-circle me-2"></i>
            Search Instructions
          </h4>
        </div>
        <div className="card-body bg-light">
          <p className="text-dark fs-5 fw-semibold">
            Please enter the client's information to the left to search the list
            of clients. If no information is entered, the entire list of clients
            will be pulled and displayed.
          </p>
        </div>
      </div>
    </React.Fragment>
  );
}

export default SearchInstructions;